export function getFormatLocaleForLanguage(language) {
  const code = languagesToFormattingLocale[language.substr(0, 2)] ? language.substr(0, 2) : 'default'
  return formattingLocales[languagesToFormattingLocale[code]]
}
const languagesToFormattingLocale = {
  ar: 'ar-001',
  ca: 'ca-ES',
  cs: 'cs-CZ',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hu: 'hu-HU',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  mk: 'mk-MK',
  nl: 'nl-NL',
  pr: 'pl-PL',
  pt: 'pt-BR',
  ru: 'ru-RU',
  sv: 'sv-SE',
  uk: 'uk-UA',
  zh: 'zh-CN',
  default: 'en-US',
}


const formattingLocales = {
  'ar-001': {
    "decimal": "\u066b",
    "thousands": "\u066c",
    "grouping": [3],
    "currency": ["", ""],
    "numerals" : ["\u0660", "\u0661", "\u0662", "\u0663", "\u0664", "\u0665", "\u0666", "\u0667", "\u0668", "\u0669"]
  },

  'ca-ES': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["", "\u00a0€"]
  },

  'cs-CZ': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0Kč"]
  },

  'de-DE': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["", "\u00a0€"]
  },

  'en-US': {
    "decimal": ".",
    "thousands": ",",
    "grouping": [3],
    "currency": ["$", ""]
  },

  'es-ES': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["", "\u00a0€"]
  },

  'fi-FI': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0€"]
  },

  'fr-FR': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0€"],
    "percent": "\u202f%"
  },

  'hu-HU': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0Ft"]
  },

  'it-IT': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["€", ""]
  },

  'ja-JP': {
    "decimal": ".",
    "thousands": ",",
    "grouping": [3],
    "currency": ["", "円"]
  },

  'ko-KR': {
    "decimal": ".",
    "thousands": ",",
    "grouping": [3],
    "currency": ["₩", ""]
  },

  'mk-MK': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["", "\u00a0ден."]
  },

  'nl-NL': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["€\u00a0", ""]
  },

  'pl-PL': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["", "zł"]
  },

  'pt-BR': {
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["R$", ""]
  },

  'ru-RU': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0руб."]
  },

  'sv-SE': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", " kr"]
  },

  'uk-UA': {
    "decimal": ",",
    "thousands": "\u00a0",
    "grouping": [3],
    "currency": ["", "\u00a0₴."]
  },

  'zh-CN': {
    "decimal": ".",
    "thousands": ",",
    "grouping": [3],
    "currency": ["¥", ""]
  },
}